export type IIceMode = "local" | "STUN" | "TURN";
